<template>
  <div class="trivia">
    <transition mode="out-in" name="main">
      <TriviaIntro @start="state=1" v-if="state===0"/>
      <TriviaDiceDrop @next="startOnCategory" v-else-if="state===1"/>
      <TriviaQuestions
          v-else-if="state===2"
          :category="category"
          :key="category"
          @next="questionsFinished"
      />
      <TriviaCongratulations @next="state=4" v-else-if="state===3"/>
      <TriviaFinished @play-again="playAgain" v-else-if="state===4"/>
    </transition>
    <transition mode="out-in" name="main">
      <TriviaEllipse v-if="state!==2" />
      <div v-else />
    </transition>
  </div>
</template>

<script setup lang="ts">
import {ref, computed, provide} from 'vue';
import TriviaIntro from "@/components/Trivia/TriviaIntro.vue";
import TriviaDiceDrop from "@/components/Trivia/TriviaDiceDrop.vue";
import TriviaQuestions from "@/components/Trivia/TriviaQuestions.vue";
import TriviaCongratulations from "@/components/Trivia/TriviaCongratulations.vue";
import TriviaFinished from "@/components/Trivia/TriviaFinished.vue";
import TriviaEllipse from "@/components/Trivia/TriviaEllipse.vue";

const state = ref(0);

const category = ref(-1);

const startOnCategory = (cat) => {
  console.log(category);
  state.value = 2;
  category.value = cat;
};

const data = ref([
  {
    //Fashion
    questions: [
      /*{
        question: "Έχει κυκλοφορήσει συσκευή IQOS σχεδιασμένη από διάσημο σχεδιαστή μόδας;",
        answers: [
          "Ναι",
          "Όχι"
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 0,
      },
      {
        question: "Ποια ήταν η τελευταία συλλεκτική συσκευή IQOS;",
        answers: [
          "OASIS",
          "NEON",
          "STARDRIFT"
        ],
        correctAnswer: 1,
        activeAnswer: -1,
        questionId: 11,
      },*/
      /*{
        question: "Ποιος σχεδιαστής θα θέλατε να σχεδιάσει την επόμενη συσκευή IQOS;",
        freetext: true,
        questionId: 1,
      }*/
      {
        question: "Ποια σχεδιάστρια εισήγαγε το «μικρό μαύρο φόρεμα»;",
        answers: [
          "Coco Chanel",
          "Vivienne Westwood",
          "Victoria Beckham"
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 18,
      },
      {
        question: "Ποια δεκαετία χαρακτηρίστηκε απο τα παντελόνια σε σχήμα καμπάνας;",
        answers: [
          "‘50",
          "‘70",
          "‘20"
        ],
        correctAnswer: 1,
        activeAnswer: -1,
        questionId: 19,
      },
    ]
  },
  {
    //Taste
    questions: [
      /*{
        question: "Πως λέγονται οι ράβδοι καπνού που μπορείς να χρησιμοποιήσεις με το IQOS ILUMA;",
        answers: [
          "TEREA",
          "HEETS",
          "FITS",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 2,
      },
      {
        question: "Τι γεύση έχει η απόλαυση για σένα;",
        freetext: true,
        value: "",
        questionId: 3,
      }*/
      /*{
        question: "Πως ονομάζονται οι δύο τελευταίες, σε κυκλοφορία, γεύσεις TEREA;",
        answers: [
          "Kona & Dore",
          "Island Beat & Electro Rouge",
          "Bronze & Amber",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 14,
      },
      {
        question: "Πως λέγονται οι ράβδοι που δεν περιέχουν φύλλα καπνού;",
        answers: [
          "TEREA",
          "LEVIA",
        ],
        correctAnswer: 1,
        activeAnswer: -1,
        questionId: 15,
      },*/
      {
        question: "Ποιες είναι οι τρεις κατηγορίες γεύσης στα TEREA;",
        answers: [
          "Έντονη, ισορροπημένη, αρωματική",
          "Έντονη, απαλή, μέτρια",
          "Μέτρια, απαλή, έντονη",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 20,
      },
      {
        question: "Σε πόσες γεύσεις κυκλοφορούν τα TEREA;",
        answers: [
          "2",
          "4",
          "13",
        ],
        correctAnswer: 2,
        activeAnswer: -1,
        questionId: 21,
      },
    ]
  },
  {
    //General
    questions: [
      /*{
        question: "Πόσοι Έλληνες καταναλωτές επιλέγουν IQOS;",
        answers: [
          "Περισσότεροι από 500.000",
          "300.000",
          "100.000"
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 4,
      },*/
      // {
      //   question: "Τι είναι το contouring;",
      //   answers: [
      //     "Είδος γυμναστικής",
      //     "Τεχνική μανικιούρ",
      //     "Τεχνική μακιγιάζ",
      //   ],
      //   correctAnswer: 2,
      //   activeAnswer: -1,
      //   questionId: 9,
      // },
      // {
      //   question: "Πόσα χρόνια πραγματοποιείται το festival «Salt Mountain»;",
      //   answers: [
      //     "3",
      //     "10",
      //     "6"
      //   ],
      //   correctAnswer: 2,
      //   activeAnswer: -1,
      //   questionId: 5,
      // }
      /*{
        question: "Πόσα χρόνια κλείνει φέτος το IQOS στην παγκόσμια αγορά;",
        answers: [
          "5",
          "10",
          "20",
        ],
        correctAnswer: 1,
        activeAnswer: -1,
        questionId: 16,
      },
      {
        question: "Πότε κυκλοφόρησε το IQOS στην Ελλάδα;",
        answers: [
          "2016",
          "2020",
          "2022",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 17,
      },*/
      {
        question: "Απο πόσες συσκευές αποτελείται η σειρά IQOS ILUMA;",
        answers: [
          "3",
          "12",
          "1",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 22,
      },
    ]
  },
  {
    //Music
    questions: [
      /*{
        question: "Σε ποια μουσική συναυλία θα ήθελες να συναντήσεις το IQOS;",
        freetext: true,
        value: "",
        questionId: 6,
      },*/
      /*{
        question: "Ποιο είναι το αγαπημένο σου τραγούδι από τους Coldplay;",
        freetext: true,
        value: "",
        questionId: 10,
      },*/
      /*{
        question: "Τι σημαίνει pop μουσική;",
        answers: [
          "Δημοφιλής",
          "Λαϊκή",
          "Έντεχνη",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 7,
      },
      {
        question: "Ποιο συγκρότημα έχει πουλήσει τους περισσότερους δίσκους παγκοσμίως μέχρι και σήμερα;",
        answers: [
          "The Beatles",
          "Aerosmith",
          "Police"
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 8,
      }*/
      /*{
        question: "Σε πόσα μεγάλα φεστιβάλ μουσικής είχε παρουσία αυτό το καλοκαίρι το IQOS;",
        answers: [
          "3",
          "1",
          "6",
        ],
        correctAnswer: 2,
        activeAnswer: -1,
        questionId: 12,
      },
      {
        question: "Σε ποιο μέρος του κόσμου σε ταξιδεύει φέτος το IQOS για να ζήσεις, μέσα σε όλα, ένα ανεπανάληπτο μουσικό event;",
        answers: [
          "Παρίσι",
          "Νέα Υόρκη",
          "Τόκιο",
        ],
        correctAnswer: 2,
        activeAnswer: -1,
        questionId: 13,
      },*/
      {
        question: "Ποιό είδος μουσικής ανήκει στην Hip Hop κουλτούρα;",
        answers: [
          "Reggae",
          "Rap",
          "Classic",
        ],
        correctAnswer: 1,
        activeAnswer: -1,
        questionId: 23,
      },
      {
        question: "Ποιος καλλιτέχνης έχει κυκλοφορήσει το Νο1 album όλων των εποχών;",
        answers: [
          "Michael Jackson",
          "Kendrick Lamar",
          "Beatles",
        ],
        correctAnswer: 0,
        activeAnswer: -1,
        questionId: 24,
      },
    ]
  },
]);

const questionsFinished = () => {
  state.value = 3;

  setTimeout(() => {
    if (state.value === 3) {
      state.value = 4;
    }
  }, 5000);
};

const playAgain = () => {
  data.value.forEach((category) => {
    category.questions.forEach((question) => {
      if (question.freetext) {
        question.value = "";
      } else {
        question.activeAnswer = -1;
      }
    });
  });

  state.value = 0;
};

provide('trivia', {
  data,
  category
});
</script>

<style scoped lang="scss">
.main-enter-active,
.main-leave-active {
  transition: opacity 0.8s ease;
}

.main-enter-from,
.main-leave-to {
  opacity: 0;
}
</style>
